module.exports = __webpack_public_path__ + "static/media/barcode.87e8239c.svg";